"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeBirthDayRequestPayloadToJSON = exports.ChangeBirthDayRequestPayloadFromJSONTyped = exports.ChangeBirthDayRequestPayloadFromJSON = void 0;
function ChangeBirthDayRequestPayloadFromJSON(json) {
    return ChangeBirthDayRequestPayloadFromJSONTyped(json, false);
}
exports.ChangeBirthDayRequestPayloadFromJSON = ChangeBirthDayRequestPayloadFromJSON;
function ChangeBirthDayRequestPayloadFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'newBirthDay': json['newBirthDay'],
    };
}
exports.ChangeBirthDayRequestPayloadFromJSONTyped = ChangeBirthDayRequestPayloadFromJSONTyped;
function ChangeBirthDayRequestPayloadToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'newBirthDay': value.newBirthDay,
    };
}
exports.ChangeBirthDayRequestPayloadToJSON = ChangeBirthDayRequestPayloadToJSON;
//# sourceMappingURL=ChangeBirthDayRequestPayload.js.map